const schema = {
    medicalRecords: {
        "label": "Upload any documentation pertaining to your past health history you would like the provider to review:",
        "placeholder": "Click or drag document photo here",
        "required": "false"
    }
};

export default schema;